import type { Root } from 'react-dom/client'

let shellRoot: Root | null = null

export function registerShellRoot(root: Root): void {
  shellRoot = root
}

export function unmountShellRoot(): void {
  if (!shellRoot) return
  shellRoot.unmount()
  shellRoot = null
}
